import { AnimatePresence } from 'framer-motion';
import FinanceSidePanel from '../finance/FinanceSidePanel';
import usePanelWidth from '../components/usePanelWidth';
import PanelResizeHandle from '../components/PanelResizeHandle';

export default function NotesNavigation({ open, onClose, children }) {
  const panel = usePanelWidth({ storageKey: 'lunadesk.panels.notes.width', defaultWidth: 280, min: 260, max: 480, breakpoint: 900 });
  return <>
    <aside ref={panel.panelRef} className="notes-navigation" data-panel="notes-navigation" style={{ width: panel.width }}>
      {children}<PanelResizeHandle label="Ширина панели заметок" bindings={panel.separatorProps}/>
    </aside>
    <AnimatePresence>{open && <FinanceSidePanel side="left" width={panel.width} mobileBreakpoint={900} open onClose={onClose} label="Библиотека заметок"><aside className="notes-navigation in-panel">{children}</aside></FinanceSidePanel>}</AnimatePresence>
  </>;
}
